import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const SalesDonutChart = ({ title, year, targetAmount, achievedAmount, activeColor, headerBg, headerTextColor }) => {
    const remainingAmount = Math.max(0, targetAmount - achievedAmount);
    const achievementRate = ((achievedAmount / targetAmount) * 100).toFixed(1);

    const donutData = [
        { value: achievedAmount, color: activeColor },
        { value: remainingAmount, color: '#E2E8F0' } 
    ];

    const formatFullNumber = (num) => num.toLocaleString();
    const formatTooltip = (value) => [`${value.toLocaleString()} 원`, ''];

    return (
        /* 개별 차트 전체를 감싸는 카드 외곽 프레임 박스 */
        <div style={{ 
            flex: '1', 
            display: 'flex', 
            flexDirection: 'column', 
            background: '#ffffff',
            border: '1px solid #E2E8F0', 
            borderRadius: '12px',
            overflow: 'hidden',
            boxSizing: 'border-box'
        }}>
            
            {/* 상단 헤더 영역 */}
            <div style={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 16px', 
                backgroundColor: headerBg, 
                borderBottom: '1px solid #E2E8F0', 
                boxSizing: 'border-box'
            }}>
                <div style={{ fontSize: '13px', fontWeight: '700', color: headerTextColor, letterSpacing: '-0.3px' }}>
                    {year}{title}
                </div>
                <div style={{ fontSize: '11px', color: '#64748B' }}></div>
            </div>

            {/* 💡 하단 바디 영역: 상하 패딩을 가장 안정적인 14px로 밸런스 조정 */}
            <div style={{ 
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: 'center', 
                justifyContent: 'flex-start',
                width: '100%',
                padding: '14px 16px', /* 💡 너무 좁지도 넓지도 않은 중간 여백 부여 */
                boxSizing: 'border-box'
            }}>
                
                {/* 💡 A. 차트 영역 박스: 높이를 106px로 미세하게 늘려 도넛 위아래 공간 확보 */}
                <div style={{ width: '110px', height: '106px', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={donutData}
                                cx="50%"
                                cy="50%"
                                innerRadius={35}  
                                outerRadius={52}  
                                paddingAngle={0}
                                dataKey="value"
                                stroke="none"
                                startAngle={90}
                                endAngle={-270}
                            >
                                {donutData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Pie>
                            <Tooltip formatter={formatTooltip} />
                        </PieChart>
                    </ResponsiveContainer>
                    
                    {/* 도넛 내부 텍스트 영역 */}
                    <div style={{ position: 'absolute', textAlign: 'center', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '70px' }}>
                        <div style={{ fontSize: '11px', fontWeight: '700', color: '#64748B', marginBottom: '1px', whiteSpace: 'nowrap', letterSpacing: '-0.3px' }}>
                            달성률
                        </div>
                        <div style={{ fontSize: '14px', fontWeight: '800', color: activeColor, lineHeight: '1.1' }}>
                            {achievementRate}%
                        </div>
                    </div>
                </div>

                {/* 💡 B. 차트와 레이블 사이 구분선: 늘어난 높이에 맞춰 세로선 길이를 74px로 패치 */}
                <div style={{ 
                    width: '1px', 
                    height: '74px', 
                    backgroundColor: '#E2E8F0', 
                    margin: '0 24px', 
                    flexShrink: 0 
                }} />

                {/* C. 레이블 영역 박스 */}
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '0px', boxSizing: 'border-box' }}>
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '13px', fontWeight: '700' }}>
                        <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#64748B', marginRight: '8px', flexShrink: 0 }}></span>
                        <span style={{ width: '95px', color: '#0F172A' }}>목표 예정액:</span>
                        <span style={{ width: '105px', textAlign: 'right', color: '#0F172A' }}>{formatFullNumber(targetAmount)}</span>
                        <span style={{ marginLeft: '4px', color: '#0F172A' }}>원</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '13px', fontWeight: '700' }}>
                        <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: activeColor, marginRight: '8px', flexShrink: 0 }}></span>
                        <span style={{ width: '95px', color: '#0F172A' }}>달성 목표액:</span>
                        <span style={{ width: '105px', textAlign: 'right', color: '#0F172A' }}>{formatFullNumber(achievedAmount)}</span>
                        <span style={{ marginLeft: '4px', color: '#0F172A' }}>원</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '13px', fontWeight: '700' }}>
                        <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#EF4444', marginRight: '8px', flexShrink: 0 }}></span>
                        <span style={{ width: '95px', color: '#EF4444' }}>남은 목표액:</span>
                        <span style={{ width: '105px', textAlign: 'right', color: '#EF4444' }}>{formatFullNumber(remainingAmount)}</span>
                        <span style={{ marginLeft: '4px', color: '#EF4444' }}>원</span>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default SalesDonutChart;
